import {Link, useNavigate, useNavigation} from "react-router-dom";
import {IoIosLock} from "react-icons/io";
import {useSession} from "../../../../../redux/Reducers/AuthReducer";

export default function Row({className, title, link, download, required_permission, ...props}) {
    const navigations = useNavigate();
    const {authActions} = useSession();


    return (
        <div className={`flex flex-row justify-center items-center gap-2 border-t-[1px] pt-3 px-2 ${className}`}>
            <div className={"flex-1 text-gray-500"}>
                <p>
                    {title}
                </p>
                {
                    required_permission && !authActions.hasActiveSubscription() && !authActions.hasBook() &&
                    <p className={"text-red-700"}>
                        you have to buy the Elite Pass to access this material
                    </p>

                }

            </div>
            {
                authActions.hasBook() ? (
                    <div className={"flex flex-col"}>
                        <div onClick={() => {
                            if (required_permission) {
                                if (authActions.hasBook()) {
                                    let a = document.createElement("a");
                                    a.href = link;
                                    a.download = title;
                                    a.target = "_blank";
                                    a.click();
                                } else {
                                    navigations("/pricing")
                                }
                            } else {
                                let a = document.createElement("a");
                                a.href = link;
                                a.download = title;
                                a.target = "_blank";
                                a.click();
                            }

                        }} className={"border-[1px] cursor-pointer rounded-md px-3 py-1"}>
                            <p className={"text-sm text-blue-500"}>
                                {
                                    required_permission && authActions.hasActiveSubscription() ?
                                        authActions.hasBook() ? "Download" : "Buy Elite Pass" : "Buy Elite Pass"
                                }


                            </p>

                        </div>
                    </div>
                ) : <IoIosLock className={"text-2xl"}/>

            }
        </div>

    )
}